import React from 'react';
import Typography from '@mui/material/Typography';
import './TwTitles.scss';

export enum TwTitleType {
  primary = 'primary',
  secondary = 'secondary',
  terciary = 'terciary',
  quaternary = 'quaternary'
}

export enum TwTitleColor {
  red = 'red',
  blue = 'blue',
  white = 'white'
}

export interface TwTitleProps {
  /**
   * Text for the title.
   */
  text: string;
  /**
   * Title type: primary or secondary.
   */
  type: TwTitleType;
  /**
   * Additional color options for the title: red, blue, white.
   */
  color?: TwTitleColor | undefined;
}

const TwTitle: React.FC<TwTitleProps> = ({ text, color, type }): JSX.Element => {
  const typeClass =
    type === TwTitleType.primary
      ? 'tw-title__type-primary' + ' tid-title'
      : type === TwTitleType.secondary
      ? 'tw-title__type-secondary' + ' tid-title'
      : type === TwTitleType.terciary
      ? 'tw-title__type-terciary' + ' tid-title'
      : 'tw-title__type-quaternary' + ' tid-title';

  const colorClass =
    color === TwTitleColor.red
      ? 'tw-title__color-red'
      : color === TwTitleColor.blue
      ? 'tw-title__color-blue'
      : color === TwTitleColor.white
      ? 'tw-title__color-white'
      : '';

  const titleClasses = `tw-title ${typeClass} ${colorClass}`;

  return (
    <div>
      <Typography role="heading" className={titleClasses}>
        {text}
      </Typography>
    </div>
  );
};

export { TwTitle };
